import { ReactNode, createContext, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { RootStateReducer } from "../reducers/RootStateReducer";

const RootStateContext = createContext({
	state: RootStateReducer.getInitialState(),
	actions: RootStateReducer.actions,
});

export const useRootStateContext = () => useContext(RootStateContext);

export const RootStateProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: RootStateReducer.getInitialState(),
		reducers: RootStateReducer.caseReducers,
	});
	return (
		<RootStateContext.Provider value={{ state, actions }}>
			{children}
		</RootStateContext.Provider>
	);
};
